import { render, staticRenderFns } from "./ViewTest.vue?vue&type=template&id=36053822&"
import script from "./ViewTest.vue?vue&type=script&lang=ts&"
export * from "./ViewTest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports